export class Queue {

    _maxParallelTasks: number;

    _activeTasks = 0;

    _queue: Task<any>[] = [];

    constructor(maxParallelTasks: number) {
        this._maxParallelTasks = maxParallelTasks;
    };

    enqueue = <T>(task: () => Promise<T>): Promise<T> => {
        return new Promise<T>((resolve, reject) => {
            this._queue.push({ task, resolve, reject });
            this.processQueue();
        });
    };

    processQueue = () => {

        if (this._activeTasks >= this._maxParallelTasks) {
            return;
        }

        const nextTask = this._queue.shift();

        if (!nextTask) {
            return;
        }

        this._activeTasks++;
        nextTask.task()
            .then(result => nextTask.resolve(result))
            .catch(error => nextTask.reject(error))
            .finally(() => {
                this._activeTasks--;
                this.processQueue();
            });
    };
}

type Task<T> = {
    task: () => Promise<T>;
    resolve: (result: T) => void;
    reject: (error: Error) => void;
};